import React, { useMemo } from 'react';

import { DISPATCHER_CONSTANTS } from './dispatcher_constants';
import { DispatcherDropZoneStyle } from './dispatcher_editor_utils';

type DispatcherTimelineLegendProps = {
  defaultDropZone?: DispatcherDropZoneStyle | null;
  highlightDropZone?: DispatcherDropZoneStyle | null;
};

const toPercentage = (value: number) => `${value * 100}%`;

export const DispatcherTimelineLegend: React.FC<DispatcherTimelineLegendProps> = ({
  defaultDropZone,
  highlightDropZone,
}) => {
  const legend = useMemo(() => {
    const entries: { name: number; position: string }[] = [];
    const { DEFAULT_TIMES_FROM: from, DEFAULT_TIMES_TILL: till } = DISPATCHER_CONSTANTS;

    for (let hour = from; hour <= till; hour += 1) {
      entries.push({
        name: hour % 12 === 0 ? 12 : hour % 12,
        position: toPercentage((hour - from) / (till - from)),
      });
    }

    return entries;
  }, []);

  return (
    <div className="dispatcher-overlays">
      {legend.map((entry) => (
        <React.Fragment key={entry.position}>
          <div className="dispatcher-legend" style={{ top: entry.position }}>
            {entry.name}
          </div>
          <div className="dispatcher-accent" style={{ top: entry.position }} />
        </React.Fragment>
      ))}
      {defaultDropZone && <div className="dispatcher-dropzone dispatcher-dropzone-default" style={defaultDropZone} />}
      {highlightDropZone && (
        <div className="dispatcher-dropzone dispatcher-dropzone-highlight" style={highlightDropZone} />
      )}
    </div>
  );
};
